import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { TimeoutWarningState } from './timeout-warning-state';
import { Observable } from 'rxjs';

@Component({
    selector: 'timeout-warning',
    template: require('./timeout-warning.component.html'),
    styles: [require('./timeout-warning.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeoutWarningComponent {

    public readonly millisecondsLeft: Observable<number>;

    constructor(state: TimeoutWarningState) {
        this.millisecondsLeft = state.millisecondsLeft;
    }
}